export const HTTP_TOKEN = Symbol('tundr-http-axios');
export const HTTP_DEFAULT_PAGE = 1;
export const HTTP_DEFAULT_PAGE_SIZE = 25;
export const HTTP_PAGE_KEY = 'page';
export const HTTP_PAGE_SIZE_KEY = 'take';
export const HTTP_RESPONSE_TOTAL_KEY = 'data.pagination.count';
export const HTTP_RESPONSE_TOTAL_PAGES_KEY = 'data.pagination.totalPages';

export const HTTP_CORRELATION_ID_HEADER_KEY = 'x-tundr-correlation-id';
